/* CAMPAIGN CUSTOM NAMES DATA */
export const GET_CAMPAIGN_CUSTOM_NAMES_LIST = "GET_CAMPAIGN_CUSTOM_NAMES_LIST"
export const SET_CAMPAIGN_CUSTOM_NAMES_LIST = "SET_CAMPAIGN_CUSTOM_NAMES_LIST"
export const ADD_CAMPAIGN_CUSTOM_NAMES = "ADD_CAMPAIGN_CUSTOM_NAMES"

/* CAMPAIGNS CUSTOM NAMES ACTIONS */
export const DELETE_CAMPAIGN_CUSTOM_NAMES = "DELETE_CAMPAIGN_CUSTOM_NAMES";

/* CAMPAIGN CUSTOM NAME PROFILE DATA */
export const GET_CAMPAIGN_CUSTOM_NAME_PROFILE = "GET_CAMPAIGN_CUSTOM_NAME_PROFILE"
export const SET_CAMPAIGN_CUSTOM_NAME_PROFILE = "SET_CAMPAIGN_CUSTOM_NAME_PROFILE"
export const UPDATE_CAMPAIGN_CUSTOM_NAME_PROFILE = "UPDATE_CAMPAIGN_CUSTOM_NAME_PROFILE"
export const SET_ERROR_CAMPAIGN_CUSTOM_NAME_PROFILE = "SET_ERROR_CAMPAIGN_CUSTOM_NAME_PROFILE"

/* LOADER */
export const SHOW_CAMPAIGN_CUSTOM_NAMES_LIST_LOADER = "SHOW_CAMPAIGN_CUSTOM_NAMES_LIST_LOADER"
export const HIDE_CAMPAIGN_CUSTOM_NAMES_LIST_LOADER = "HIDE_CAMPAIGN_CUSTOM_NAMES_LIST_LOADER"
